const globalModalService = [
  'globalNotificationsModel',
  '$uibModal',
  'urlService',
  'modalScreenService',
  function (
    globalNotificationsModel,
    $uibModal,
    urlService,
    modalScreenService
  ) {
    const modalKeyHandlers = {
      WIN_RATE: ({ recentProjectCount, winNumber, modalSeverity }) => {
        $uibModal.open({
          templateUrl: urlService.templateUrl('contractor/home/win_rate_modal'),
          controller: 'WinRateModalCtrl',
          controllerAs: '$ctrl',
          windowClass: 'v3-modal-simple large win-rate-modal',
          resolve: {
            inputData: () => ({
              recentProjectsReceived: recentProjectCount,
              projectsWon: winNumber,
              modalSeverity,
            }),
          },
        })
      },
      UNSUBSCRIBE_CONFIRMATION: ({
        communicableId,
        communicableType,
        communicationType,
        subscriptionType,
        subscriptionText,
      }) => {
        modalScreenService.initDetachedComponent({
          component: 'unsubscribeConfirmationModal',
          windowClass: 'v3-modal-simple extra-thin',
          inputData: {
            communicableId: communicableId,
            communicableType: communicableType,
            communicationType: communicationType,
            subscriptionType: subscriptionType,
            subscriptionText: subscriptionText,
          },
        })
      },
    }

    return {
      checkActiveGlobalModal(shouldCacheResponse) {
        if (UserData.user_signed_in() && !UserData.is_admin()) {
          globalNotificationsModel
            .getModalToShow(shouldCacheResponse)
            .then((modalData) => {
              if (modalData) {
                const { alertKey, alertData } = modalData
                if (alertKey) modalKeyHandlers[alertKey](alertData)
              }
            })
            .catch((e) => {
              console.error(e)
            })
        }
      },
    }
  },
]

export default globalModalService
